module.exports = __webpack_public_path__ + "media/images/providers/stripe_connect-ecbac96fa9c7d7bcb5a3adcc08e28aad.png";